import { useEffect } from 'react';
import { lockScroll, unlockScroll } from '../utils/scrollUtils';

/**
 * Lock body scroll while a modal/overlay is open.
 * Prevents background scrolling on public pages with native window scroll.
 * @param {boolean} isLocked - Whether scroll should be locked
 */
export function useScrollLock(isLocked) {
  useEffect(() => {
    if (isLocked) lockScroll();
    return () => {
      if (isLocked) unlockScroll();
    };
  }, [isLocked]);
}
